import { createFileRoute } from "@tanstack/react-router";
import { MainLayout } from "~/components/layout/MainLayout";
import { ManifestoSection } from "~/components/sections/ManifestoSection";

export const Route = createFileRoute("/manifesto")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <MainLayout>
      <ManifestoSection animated={false} />
    </MainLayout>
  );
}